import React from 'react'

const Resources = () => {
  return (
    <div className='default-grid a-center'>
    <div className='column-2 centered'>
      <h1>Resources</h1>
      <h2>Light Pollution Is Completely Reversible!</h2>
      <img src='https://www.noaa.gov/sites/default/files/styles/landscape_width_1275/public/legacy/image/2019/Jun/Dollhouse%20Rock%2C%20Canyonlands%20National%20Park_lg2.jpg' alt='night sky before light pollution' width="400px" height="200px"/>
      <h3>Ways To Help From Your Home</h3>
        <p>
          <a href='https://www.darksky.org/' target="#">https://www.darksky.org/</a>
        </p>
        <p>
          <a href='https://www.darkskysociety.org/' target="#">https://www.darkskysociety.org/</a>
        </p>
        <p>
          <a href='https://www.conserve-energy-future.com/impressive-ways-reduce-light-pollution.php' target="#">https://www.conserve-energy-future.com/impressive-ways-reduce-light-pollution.php</a>
        </p>
        <p>
          <a href='https://cescos.fau.edu/observatory/lightpol-prevent.html' target="#">https://cescos.fau.edu/observatory/lightpol-prevent.html</a>
        </p>
      <h3>Ways To Help From Your Vehicle</h3>
        <p>
          <a href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6978440/' target="#">https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6978440/</a>
        </p>
        <p>
          <a href='https://www.epa.gov/transportation-air-pollution-and-climate-change/what-you-can-do-reduce-pollution-vehicles-and' target="#">https://www.epa.gov/transportation-air-pollution-and-climate-change/what-you-can-do-reduce-pollution-vehicles-and</a>
        </p>
      <h3>Cheap And Effective Products That Helps Reduce Light Pollution</h3>
      <li> 
        <a href='https://www.amazon.com/Satco-11407-9-8W-3000K-Medium-spread120V/dp/B084LG8814/ref=sr_1_4?crid=35HPL5UEEB6G1&keywords=warm%2Blight%2Bbulbs%2B3000K&qid=1682137570&sprefix=warm%2Blight%2Bbulbs%2B3000k%2Caps%2C87&sr=8-4&th=1' target="#">Light Bulbs For Homes</a>
      </li>
      <li> 
        <a href='https://www.amazon.com/Philips-3757NA-LongerLife-Miniature-Bulb/dp/B0173MKJ0S/ref=asc_df_B0173MKJ0S/?tag=hyprod-20&linkCode=df0&hvadid=241918478831&hvpos=&hvnetw=g&hvrand=1013505748409740340&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=1022762&hvtargid=pla-449494287599&psc=1' target="#">Light Bulbs For Vehicles</a>
      </li>
      <li>
        <a href='https://www.amazon.com/MORESEC-Operated-Upgraded-Wardrobe-Cupboard/dp/B0BVVFYGJ3/ref=sr_1_48?hvadid=580555475964&hvdev=c&hvlocphy=1022762&hvnetw=g&hvqmt=e&hvrand=16997431776039621481&hvtargid=kwd-193771302&hydadcr=8459_13498084&keywords=motion%2Bdetector%2Blights&qid=1682173950&sr=8-48&th=1' target="#">Motion Sensor Lights</a>
      </li>
      <li>
        <a href='https://www.amazon.com/Lumary-2-4GHz-WiFi-Smart-Outlet/dp/B0BWMR7F3C/ref=sr_1_50_sspa?crid=16Q24ZXZ94IY3&keywords=wifi%2Boutlets%2Bfor%2Bhome&qid=1682174062&sprefix=wifi%2Boutl%2Caps%2C160&sr=8-50-spons&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUExTkZZSjA5Q1dEN0xDJmVuY3J5cHRlZElkPUExMDIwNjM3M0FPUjZYUzhCSjEwRiZlbmNyeXB0ZWRBZElkPUEwNTc1OTY2MVVZR0kzRFM1V081VyZ3aWRnZXROYW1lPXNwX2J0ZiZhY3Rpb249Y2xpY2tSZWRpcmVjdCZkb05vdExvZ0NsaWNrPXRydWU&th=1' target="#">Smart Outlets</a>
      </li>
      <li>
        <a href='https://www.amazon.com/NICETOWN-Blackout-Curtain-Panels-Livingroom/dp/B015SJ8AM2/ref=sr_1_138_sspa?crid=38WC099CTOUHG&keywords=blackout%2Bcurtains&qid=1682166745&sprefix=blackout%2Bcurtains%2Caps%2C93&sr=8-138-spons&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUEzODdCMk1RNEhYRlFPJmVuY3J5cHRlZElkPUEwMDQ2ODYzMUZXWkFVWDlGTE9ITCZlbmNyeXB0ZWRBZElkPUEwNjE5Mzg2Mk1USFRCNExRU1VOQiZ3aWRnZXROYW1lPXNwX2J0ZiZhY3Rpb249Y2xpY2tSZWRpcmVjdCZkb05vdExvZ0NsaWNrPXRydWU&th=1' target="#">Blackout Curtains</a>
      </li>

      <h3>Donate To Help Protect The Sky</h3>
      <p><a href='https://act.darksky.org/one-time' target="#">https://act.darksky.org/one-time</a>
  </p>
  <p><a href='https://www.astronomerswithoutborders.org/get-involved/support-us' target="#">https://www.astronomerswithoutborders.org/get-involved/support-us</a></p>
    </div>
    </div>
  )
}

export default Resources
